import React from 'react';

import { DescriptionProps } from './interfaces';

const Description = ({ description }: DescriptionProps) => {
  return (
    <section>
      <h2 className="m-0 font-suisse-intl-mono text-disclosure-lg text-primary-magenta">
        Description
      </h2>
      <p className="text-primary mt-8 font-suisse-works text-body-md">{description}</p>
    </section>
  );
};

export default Description;
